var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        fullscreen: "",
        "append-to-body": "",
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "custom-class": "qr-scanner-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.handleDialogClosed,
      },
    },
    [
      _c("div", { staticClass: "scanner-page" }, [
        _c("div", { staticClass: "scanner-header" }, [
          _c("div", { staticClass: "scanner-title" }, [_vm._v(" 扫描二维码 ")]),
          _c("div", { staticClass: "close-button", on: { click: _vm.close } }, [
            _vm._v(" × "),
          ]),
        ]),
        _c("div", { staticClass: "scanner-body" }, [
          _c("div", { staticClass: "qr-reader", attrs: { id: "qr-reader" } }),
          _c("div", { staticClass: "scan-box" }, [
            _c("div", { staticClass: "corner top-left" }),
            _c("div", { staticClass: "corner top-right" }),
            _c("div", { staticClass: "corner bottom-left" }),
            _c("div", { staticClass: "corner bottom-right" }),
            _vm.scanning ? _c("div", { staticClass: "scan-line" }) : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "scanner-tip" },
            [
              _vm.errorMessage
                ? [
                    _c("div", { staticClass: "error-message" }, [
                      _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
                    ]),
                  ]
                : [
                    _c("div", [_vm._v(" 请将二维码放入扫描框内 ")]),
                    _c("div", { staticClass: "sub-tip" }, [
                      _vm._v(" 默认使用后置摄像头 "),
                    ]),
                  ],
            ],
            2
          ),
          _vm.cameras.length > 1 && _vm.scanning
            ? _c(
                "div",
                {
                  staticClass: "switch-camera",
                  on: { click: _vm.switchCamera },
                },
                [
                  _c("i", { staticClass: "el-icon-refresh" }),
                  _vm._v(" 切换摄像头 "),
                ]
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "scanner-footer" },
          [
            _c(
              "el-button",
              {
                staticClass: "close-scan-button",
                attrs: { plain: "", size: "medium" },
                on: { click: _vm.close },
              },
              [_vm._v(" 关闭扫码 ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }